import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { FormikFormField } from '@frontman/rt-protections-ui';
import {
  CoverageCheckupState,
  goToNextStep,
  updateCoverageCheckupState,
} from '../../../store/step';
import Select from '@ramsey-design-system/select';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createSelectOptionSchema } from '../../schema';

import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';
import { homeAndMortgageRange } from '../../../utils/shared';

function HomeValueStep(): ReactElement {
  const dispatch = useDispatch();
  const { homeValue: homeValue } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('home_worth');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Your Home"
          subHeader="Your're a homeowner! Lets see how much equity you have in your home."
        />
      </GrayCard>
      <CardPadding>
        <CardHeader
          header="What's your home worth?"
          subHeader="In other words, how much would your home sell for today?"
        />
        <Formik
          initialValues={{ homeValue }}
          onSubmit={onSubmit}
          validationSchema={createSelectOptionSchema('homeValue')}
        >
          <Form ref={formRef}>
            <FormikFormField<CoverageCheckupState>
              id="homeValue"
              name="homeValue"
              className="u-spacingBlockMd"
              inputComponent={Select}
              rdsAttributes={{ length: 'lg' }}
            >
              <option value="">Select an Option</option>
              {homeAndMortgageRange.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </FormikFormField>
            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { HomeValueStep };
